module.exports = __webpack_public_path__ + "img/1.62b527f6.png";